import { render, staticRenderFns } from "./SoilAdvise.vue?vue&type=template&id=fc5970b6&"
import script from "./SoilAdvise.vue?vue&type=script&lang=js&"
export * from "./SoilAdvise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports